<template>
  <MailchimpSubscribe>
    <form
      class="mc-form"
      @submit.prevent="subscribe"
    >
      <div v-if="message !== false" class="message">
        <p v-html="message"></p>
      </div>
      <div v-else class="form-inner">
        <p class="cta" v-html="cta"/>
        <input
          v-model="email"
          ref="input"
          type="email"
          name="EMAIL"
          value=""
          :placeholder="placeholder"
          required
        >
        <button id="sub" class="button-init" :click="subscribe">
          <span>Subscribe</span>
        </button>
      </div>
    </form>
  </MailchimpSubscribe>
</template>

<script>
import jsonp from 'jsonp'
import toQueryString from 'to-querystring'
import styled from 'vue-styled-components'
import * as _ from '@/styles/mixins'

const MailchimpSubscribe = styled.div`
  width: 100%;
  height: 100%;
  * {
    color: white!important;
    text-transform: uppercase;
  }
  .message {
    font-size: 1.5rem;
    color: white;
    text-align: left;
    margin: auto;
  }
  .message * {
    color: white;
    text-transform: uppercase;
  }
  .message p a {
    color: transparent;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke-color: white;
    -webkit-text-stroke-width: 1px;
    -webkit-font-smoothing: antialiased;
  }
  .form-inner,
  .message {
    line-height: 1.35;
    width: 100%;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    width: 100%;
    border: 2px solid white;
    margin: 0 auto 1rem;
    background-color: black!important;
    button:hover {
      text-decoration: underline;
    }
    ${_.media.desktop`
      flex-direction: row;
      align-items: center;
      height: 5rem;
      padding: 0 1rem;
      margin: 0;
      p {
        padding-top: 4px;
      }
      button {
        padding-top: 5px;
        padding-left: 1rem;
      }
    `}
  }
  .cta {
    padding-right: 1rem;
    padding-bottom: 1rem;
    ${_.media.desktop`
      padding-bottom: 0;
    `}
  }
  .form-inner input[type=email],
  .form-inner input[type=text],
  .form-inner input[type=tel] {
    margin: auto;
    border-bottom: 1px solid white;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-radius: 0;
    margin: 0;
    text-align: left;
    color: white;
    -webkit-text-fill-color: white;
    padding: 0;
    text-transform: uppercase;
    background-color: transparent;
    padding-bottom: 0;
    transform: translateY(0);
    flex: 1;
    padding-bottom: 2px;
  }
  .form-inner input[type=email]:focus,
  .form-inner input[type=text]:focus,
  .form-inner input[type=tel]:focus,
  input:-internal-autofill-selected {
    outline: none!important;
    box-shadow: 0;
    background-color: transparent!important;
  }
  ::-webkit-input-placeholder,
  ::-moz-placeholder {
    color: white!important;
    opacity: 1;
  }
  #sub {
    text-align: right;
    padding-top: 1rem;
    padding-right: 0;
    ${_.media.desktop`
      padding-top: 0;
    `}
  }
`

export default {
  name: 'McSubscribe',
  components: {
    MailchimpSubscribe
  },
  props: [
    'list',
    'placeholder',
    'success',
    'cta'
  ],
  data () {
    return {
      email: '',
      status: false,
      message: false
    }
  },
  methods: {
    subscribe () {
      const getAjaxUrl = url => url.replace('/post?', '/post-json?')
      const EMAIL = { EMAIL: this.$refs.input.value }
      const params = toQueryString(EMAIL)
      const url = `${getAjaxUrl(this.list)}&${params}`
      jsonp(
        url,
        {
          param: 'c'
        },
        (err, data) => {
          if (data.result === 'error') {
            this.status = err
            this.message = data.msg
          } else if (data.result === 'success') {
            this.status = 'success'
            this.message = this.success
          } else {
            this.status = 'error'
            this.message = data.msg
          }
        }
      )
    }
  }
}
</script>
